import '../Sass/App.scss';
import React, { useCallback, useContext, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Cropper from 'react-easy-crop';
import { Card } from './Card2';
import { MWContext } from '../Contexts/MWContext';
import getCroppedImg from '../Helpers/cropImage';

export function Modify(props) {

    const dev_standards = ['function','listener','procedure','program','special'];
    const ml_types = ['normal','ifthen'];
    const { IMAGE_ROOT } = useContext(MWContext);

    const [cardData, setCardData] = useState({...props.cardData});
    const [cardType, setCardType] = useState(dev_standards.includes(props.cardData.card_type) ? props.cardData.card_type : 'special');
    const [special, setSpecial] = useState(dev_standards.includes(props.cardData.card_type) ? (props.cardData.special || 'tbd') : props.cardData.card_type);
    const [name1, setName1] = useState(props.cardData.name_1 || '');
    const [name2, setName2] = useState(props.cardData.name_2 || '');
    const [argument, setArgument] = useState(props.cardData.argument || '');
    const [suffix, setSuffix] = useState(props.cardData.suffix || '');
    const [quantity, setQuantity] = useState(props.cardData.quantity || 1);
    const [xLevel, setXLevel] = useState(props.cardData.x_level || 1);
    const [description1, setDescription1] = useState(props.cardData.description_1 || '');
    const [description2, setDescription2] = useState(props.cardData.description_2 || '');
    const [desc, setDesc] = useState(props.cardData.description || '');
    const [header1, setHeader1] = useState(props.cardData.header_1 || '');
    const [header2, setHeader2] = useState(props.cardData.header_2 || '');
    const [thenText, setThenText] = useState(props.cardData.then_text || '');
    const [elseText, setElseText] = useState(props.cardData.else_text || '');

    function assetUrl(path) {
        if (!path) {
            return null;
        }

        if (/^https?:\/\//i.test(path)) {
            return path;
        }

        if (path.startsWith('/game_assets/')) {
            return IMAGE_ROOT.replace(/\/game_assets\/?$/, '') + path;
        }

        return IMAGE_ROOT + '/' + path.replace(/^\/+/, '');
    }

    const initialImageSrc = assetUrl(props.cardData.image);
    const initialSpecialImageSrc = assetUrl(props.cardData.special_image);
    const initialBackImageSrc = assetUrl(props.cardData.back_image);
    const [imageSrc, setImageSrc] = useState(initialImageSrc);
    const [specialImageSrc, setSpecialImageSrc] = useState(initialSpecialImageSrc);
    const [backImageSrc, setBackImageSrc] = useState(initialBackImageSrc);
    const [imageChanged, setImageChanged] = useState(false);
    const [specialImageChanged, setSpecialImageChanged] = useState(false);
    const [backImageChanged, setBackImageChanged] = useState(false);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [specialCrop, setSpecialCrop] = useState({ x: 0, y: 0 });
    const [backCrop, setBackCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [specialZoom, setSpecialZoom] = useState(1);
    const [backZoom, setBackZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [specialCroppedAreaPixels, setSpecialCroppedAreaPixels] = useState(null);
    const [backCroppedAreaPixels, setBackCroppedAreaPixels] = useState(null);
    const cardImageAspect = cardType === 'program' ? 1 / 1 : 2 / 1;
    const backImageIsLandscape = ['viral_listener', 'viral_function'].includes(cardType);
    const backImageAspect = backImageIsLandscape ? 1.43 / 1 : 1 / 1.4;

    function changeCard(event, changer, elem) {
        let newValue = event.target.value;
        let newElement = elem;
        const newCardData = {...cardData};

        changer(newValue);

        if (elem === 'card_type' && newValue === 'special') {
            newValue = special;
        }

        if (elem === 'special_type') {
            newElement = 'card_type';
        }

        newCardData[newElement] = newValue;
        setCardData(newCardData);
    }

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const onSpecialCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setSpecialCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const onBackCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setBackCroppedAreaPixels(croppedAreaPixels);
    }, []);

    async function onFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            setImageSrc(reader.result);
            setImageChanged(true);
        };
        reader.readAsDataURL(file);
    }

    async function onSpecialFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            setSpecialImageSrc(reader.result);
            setSpecialImageChanged(true);
        };
        reader.readAsDataURL(file);
    }

    async function onBackFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            setBackImageSrc(reader.result);
            setBackImageChanged(true);
        };
        reader.readAsDataURL(file);
    }

    function useDefaultBackImage() {
        const newCardData = {...cardData, back_image: ''};
        setCardData(newCardData);
        setBackImageSrc(null);
        setBackImageChanged(true);
        setBackCroppedAreaPixels(null);
    }

    async function saveChanges() {
        let updatedCardData = {...cardData};

        if (imageChanged && imageSrc) {
            updatedCardData.image = croppedAreaPixels ? await getCroppedImg(imageSrc, croppedAreaPixels) : imageSrc;
        }

        if (specialImageChanged && specialImageSrc) {
            updatedCardData.special_image = specialCroppedAreaPixels ? await getCroppedImg(specialImageSrc, specialCroppedAreaPixels) : specialImageSrc;
        }

        if (backImageChanged) {
            updatedCardData.back_image = backImageSrc
                ? (backCroppedAreaPixels ? await getCroppedImg(backImageSrc, backCroppedAreaPixels) : backImageSrc)
                : '';
        }

        props.changeHandler(props.indexInSeries, updatedCardData);
    }

    return (
        <Grid container spacing={2}>
            <Grid xs={12} sm={12} md={4} lg={4}>
                <div className="modify-card-preview">
                    <Card cardData={cardData} indexInSeries={props.indexInSeries} cardWidth={300} notDraggable clickHandler={() => {}} />
                </div>
            </Grid>
            <Grid xs={12} sm={12} md={8} lg={8}>
                <h4>{props.heading || 'Modify card for playtesting'}</h4>
                <p className='explanation' style={{marginBottom: '20px'}}>{props.explanation || 'Modifications made here will last only for the duration of this playtest.'}</p>
                {props.error && <div className="auth-error">{props.error}</div>}
                <div className="modify-card-form">
                    <div className="modify-card-grid">
                        <div className="modify-card-field">
                            <div className='green-code'>Card type:</div>
                            <select className="codebase-select" onChange={(e) => changeCard(e,setCardType,'card_type')} value={cardType}>
                                <option value={'function'}>function</option>
                                <option value={'listener'}>listener</option>
                                <option value={'procedure'}>procedure</option>
                                <option value={'program'}>program</option>
                                <option value={'special'}>special (enter text)</option>
                                <option value={'viral_listener'}>viral listener</option>
                                <option value={'viral_function'}>viral function</option>
                                <option value={'ifthen'}>ml: if/then</option>
                                <option value={'normal'}>ml: normal</option>
                            </select>
                        </div>
                        { cardType === 'special' &&
                            <div className="modify-card-field">
                                <div className='green-code'>Special card type:</div>
                                <input className="codebase-select" value={special} onChange={(e) => changeCard(e,setSpecial,'special_type')} />
                            </div>
                        }
                        { ml_types.includes(cardType) &&
                            <div className="modify-card-field">
                                <div className='green-code'>X level:</div>
                                <select className="codebase-select" onChange={(e) => changeCard(e,setXLevel,'x_level')} value={xLevel}>
                                    <option value={'1'}>1</option>
                                    <option value={'2'}>2</option>
                                    <option value={'3'}>3</option>
                                </select>
                            </div>
                        }
                        <div className="modify-card-field">
                            <div className='green-code'>Quantity</div>
                            <span className='explanation'>Number of copies included in this codebase.</span>
                            <input className="codebase-select" type="number" min="0" value={quantity} onChange={(e) => changeCard(e,setQuantity,'quantity')} />
                        </div>
                        <div className="modify-card-field">
                            <div className='green-code'>Card title #1</div>
                            <span className='explanation'>Light/unbolded 'prefix' text.</span>
                            <input className="codebase-select" value={name1} onChange={(e) => changeCard(e,setName1,'name_1')} />
                        </div>
                        <div className="modify-card-field">
                            <div className='green-code'>Card title #2</div>
                            <span className='explanation'>Bold 'focus' text.</span>
                            <input className="codebase-select" value={name2} onChange={(e) => changeCard(e,setName2,'name_2')} />
                        </div>
                        <div className="modify-card-field">
                            <div className='green-code'>Argument</div>
                            <span className='explanation'>Appears in parentheses next to card's title.</span>
                            <input className="codebase-select" value={argument} onChange={(e) => changeCard(e,setArgument,'argument')} />
                        </div>
                        <div className="modify-card-field">
                            <div className='green-code'>Suffix</div>
                            <span className='explanation'>Such as the all-important semicolon.</span>
                            <input className="codebase-select" value={suffix} onChange={(e) => changeCard(e,setSuffix,'suffix')} />
                        </div>
                    </div>
                    { dev_standards.includes(cardType) ? (
                        <>
                        <div className="modify-card-field modify-card-field-full">
                            <div className='green-code'>Description block #1</div>
                            <textarea rows='4' className="codebase-select" value={description1} onChange={(e) => changeCard(e,setDescription1,'description_1')} />
                        </div>
                        <div className="modify-card-field modify-card-field-full">
                            <div className='green-code'>Description block #2</div>
                            <textarea rows='4' className="codebase-select" value={description2} onChange={(e) => changeCard(e,setDescription2,'description_2')} />
                        </div>
                        <div className="modify-card-grid">
                            <div className="modify-card-field">
                                <div className='green-code'>Header #1</div>
                                <span className='explanation'>Appears before first description block.</span>
                                <input className="codebase-select" value={header1} onChange={(e) => changeCard(e,setHeader1,'header_1')} />
                            </div>
                            <div className="modify-card-field">
                                <div className='green-code'>Header #2</div>
                                <span className='explanation'>Appears between first and second description blocks.</span>
                                <input className="codebase-select" value={header2} onChange={(e) => changeCard(e,setHeader2,'header_2')} />
                            </div>
                        </div>
                        </>
                    ) : (
                        <div className="modify-card-field modify-card-field-full">
                            <div className='green-code'>{ cardType === 'ifthen' ? 'IF text:' : 'Description:' }</div>
                            <textarea rows='4' className="codebase-select" value={desc} onChange={(e) => changeCard(e,setDesc,'description')} />
                        </div>
                    ) }
                    { cardType === 'ifthen' ? (
                        <>
                        <div className="modify-card-field modify-card-field-full">
                            <div className='green-code'>THEN text:</div>
                            <textarea rows='4' className="codebase-select" value={thenText} onChange={(e) => changeCard(e,setThenText,'then_text')} />
                        </div>
                        <div className="modify-card-field modify-card-field-full">
                            <div className='green-code'>ELSE text:</div>
                            <textarea rows='4' className="codebase-select" value={elseText} onChange={(e) => changeCard(e,setElseText,'else_text')} />
                        </div>
                        </>
                    ) : null }
                    <div className="modify-card-field modify-card-field-full">
                        <div className='green-code'>Card image</div>
                        <span className='explanation'>
                            This image appears in the main art area of development cards. {cardType === 'program' ? 'Program cards use a square crop.' : 'Most cards use a 2:1 crop.'}
                        </span>
                        <div style={{marginTop: 5}}>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={onFileChange}
                            />
                            {imageSrc && (
                                <div className={cardType === 'program' ? 'modify-card-cropper modify-card-cropper-square' : 'modify-card-cropper'}>
                                    <Cropper
                                        image={imageSrc}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={cardImageAspect}
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modify-card-field modify-card-field-full">
                        <div className='green-code'>Special image</div>
                        <span className='explanation'>This square image appears as the small special icon on supported cards.</span>
                        <div style={{marginTop: 5}}>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={onSpecialFileChange}
                            />
                            {specialImageSrc && (
                                <div className="modify-card-cropper modify-card-cropper-square">
                                    <Cropper
                                        image={specialImageSrc}
                                        crop={specialCrop}
                                        zoom={specialZoom}
                                        aspect={1 / 1}
                                        onCropChange={setSpecialCrop}
                                        onZoomChange={setSpecialZoom}
                                        onCropComplete={onSpecialCropComplete}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modify-card-field modify-card-field-full">
                        <div className='green-code'>Card back override</div>
                        <span className='explanation'>
                            Optional. Leave blank to use the Codebase default card back. {backImageIsLandscape ? 'Viral backs use a 1.43:1 landscape crop.' : 'Development card backs use a 1:1.4 portrait crop.'}
                        </span>
                        <div style={{marginTop: 5}}>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={onBackFileChange}
                            />
                            <button className="cli-button" type="button" onClick={useDefaultBackImage}>use default back</button>
                            {backImageSrc && (
                                <div className={backImageIsLandscape ? 'modify-card-cropper modify-card-cropper-landscape' : 'modify-card-cropper modify-card-cropper-portrait'}>
                                    <Cropper
                                        image={backImageSrc}
                                        crop={backCrop}
                                        zoom={backZoom}
                                        aspect={backImageAspect}
                                        onCropChange={setBackCrop}
                                        onZoomChange={setBackZoom}
                                        onCropComplete={onBackCropComplete}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div style={{width: '100%', float: 'right'}}>
                    <button className="cli-button-red" onClick={() => props.setModifyOpen(false)}>cancel</button>
                    <button className="cli-button" onClick={saveChanges}>save</button>
                </div>
            </Grid>
        </Grid>
    );
}
